import React from 'react';
import { withStyles } from '@material-ui/styles';
import MuiTableBody from '@material-ui/core/TableBody';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.secondary['0'],
    '& a': {
      color: 'unset !important',
    },
    '& label': {
      top: '3px',
      marginBottom: '0',
    },
    '& svg': {
      cursor: 'pointer',
      opacity: '0.7',
      transition: 'opacity 0.3s ease-in-out',
      '&:hover': {
        opacity: '1',
        color: theme.palette.secondary['1000'],
      },
    },
    '& .more-actions svg': {
      opacity: '0.2',
    },
    '& .truncate-text': {
      '&--25ch': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        wordBreak: 'normal',
        maxWidth: '25ch',
      },
      '&--50ch': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        wordBreak: 'normal',
        maxWidth: '50ch',
      },
      '&--100': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        wordBreak: 'normal',
        maxWidth: '100px',
      },
      '&--200': {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        wordBreak: 'normal',
        maxWidth: '200px',
      },
    },
  },
});

const TableBody = (props) => {
  const { classes } = props;
  return (
    <MuiTableBody
      {...props}
      classes={{ root: classes.root }}
    >
      {props.children}
    </MuiTableBody>
  );
};

export default withStyles(styles)(TableBody);
